import Vue from 'vue';
import Vuex from 'vuex';
import apiClient from './apiClient';
import router from './router';
import isAuthenticatedMixin from './mixins/isAuthenticatedMixin';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    config: {
      'title': process.env.VUE_APP_TITLE,
      'payoff': '',
    },
    session: {
      'user': null
    },
    theme: 'light',
  },
  mutations: {
    setConfig(state, config) {
      state.config = config;
    },
    setUser(state, user) {
      state.session.user = user;
    },
    updateSession(state, newState) {
      state.session = { ...state.session, ...newState };
    },
    resetSession(state) {
      state.session = { user: null };
    },
    toggleTheme(state) {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    },
  },
  actions: {
    initializeApp({ commit, dispatch }) {
      return apiClient.get('/dev/config')
        .then((response) => {
          commit('setConfig', response.data.data);
          if(response.data.user) commit('setUser', response.data.user);
          console.log('App configuration loaded');
          return true;
        })
        .catch((error) => {
          console.error('Failed to initialize app', error);
        });
    },

    logout({ commit, state }) {
      commit('resetSession');
      router.push('/');
    },
  },
});